<template>
  <div class="">
    <div class="content">
      <MopCancelPopup
        v-if="bShowMopPopup"
        @cancel="closePopup()"
        @confirm="confirmCancellation"
      ></MopCancelPopup>

      <div class="filters">
        <div class="buttons">
          <a href="https://datastudio.google.com/u/0/reporting/1hNs8L1FJJpFfibv5m4_e8LE-bbKR9FOB/page/p_8xwgnt873c" class="v-btn theme--light outline success">
            <span class="v-btn__content">Informe de Looker</span>
          </a>
        </div>
        <v-switch
          class="filter switch"
          v-model="confirm"
          :label="$t('admin.views.mop.confirm')"
          inset
        >

        </v-switch>
        <v-text-field
          class="filter"
          v-model="search"
          append-icon="search"
          :label="$t('admin.views.mop.petitions')"
          single-line
          hide-details
        ></v-text-field>
        <v-select
          class="filter"
          :items="['Confirmado', 'Pendiente']"
          v-model="filterStatus"
          :label="$t('admin.views.mop.status')"
          clearable
          single-line
        ></v-select>
      </div>
      <v-data-table
        :custom-filter="filter"
        :headers="headers"
        :items="requests"
        class="elevation-1"
        :no-results-text="message_not_found"
        :rows-per-page-items="rows_per_page"
        :pagination.sync="pagination"
        :search="search"
        :rows-per-page-text="message_rows_per_page"
      >
        <template v-slot:items="props">
          <td>{{ formatDate(props.item.log_date) }}</td>
          <td>
            {{ props.item.restaurant_site }} -
            {{ props.item.restaurant_name }}
          </td>
          <td>{{ props.item.user_name }}</td>
          <td>{{ formatDate(props.item.start_date) }}</td>
          <td>{{ formatDate(props.item.end_date) }}</td>
          <td style="width: 35%">{{ props.item.value }}</td>
          <td>{{ props.item.cancel }}</td>
          <td>
            <select
              v-model="props.item.status"
              @change="updateStatus(props.item, $event)"
            >
              <option
                v-for="(option, index) in status"
                :value="index"
                :key="index"
              >
                {{ option }}
              </option>
            </select>
          </td>
        </template>
      </v-data-table>
    </div>
  </div>
</template>

<script>
import i18n from "@/i18n";
import Mop from "@/components/domain/admin/Mop";
import MopCancelPopup from "@/components/domain/admin/MopCancelPopup";

export default {
  name: "Mop",
  props: { page: String },
  components: { Mop, MopCancelPopup },
  data() {
    return {
      bShowMopPopup: false,
      currentRequest: false,
      headers: [
        { text: i18n.t('general.headers.date'), value: "log_date" },
        { text: i18n.t('general.headers.restaurant'), value: "restaurant" },
        { text: i18n.t('general.headers.user'), value: "user" },
        { text: i18n.t('general.headers.start_date'), value: "start_date" },
        { text: i18n.t('general.headers.end_date'), value: "end_date" },
        { text: i18n.t('general.headers.reason'), value: "value" },
        { text: i18n.t('general.headers.cancel'), value: "cancel" },
        { text: i18n.t('general.headers.status'), value: "status" }
      ],
      search: "",
      filterStatus: "",
      id: -1,
      message_not_found: i18n.t('general.message_not_found'),
      message_rows_per_page: i18n.t('general.message_rows_per_page'),
      rows_per_page: [10, 50, 100, { text: i18n.t('general.all'), value: -1 }],
      pagination: {
        rowsPerPage: -1,
        sortBy: "log_date",
        descending: false
      },
      status: { "1": i18n.t('general.state.pending'), "2": i18n.t('general.state.confirmed'), "3": i18n.t('general.state.canceled') }
    };
  },
  computed: {
    requests() {
      var result = ObjectToArray(this.$store.getters["mop/getRequests"]);
      console.log(result);
      return result;
    },
    confirm: {
      get() {
        return this.$store.getters["mop/getConfirm"];
      },
      set(value) {
        this.$store.dispatch("mop/updateAutoConfirm", value);
      }
    }
  },
  methods: {
    updateStatus(request, event) {
      console.log(request);
      console.log(event);
      this.currentRequest = request;
      var params = {
        id: request.id,
        params: {
          status: parseInt(request.status)
        }
      };

      if (params.params.status == 3) {
        this.bShowMopPopup = true;
      } else {
        this.$store.dispatch("mop/update", params);
      }
    },
    confirmCancellation(value) {
      this.bShowMopPopup = false;
      console.warn(value);
      // TODO - Send request to API
      var params = {
        id: this.currentRequest.id,
        params: {
          status: 3,
          cancel_value: value
        }
      };
      var self = this;
      this.$store.dispatch("mop/update", params).then(function() {
        self.$store.dispatch("mop/loadRequests", {});
      });
    },
    formatDate(date) {
      return moment(date).format("DD/MM/YYYY HH:mm ");
    },
    filter(items, search, filter) {
      var aItems = [];
      items.forEach(item => {
        if (
          filter(this.status[item.status], search) ||
          filter(item.restaurant_name, search) ||
          filter(item.restaurant_site, search)
        ) {
          if (
            this.filterStatus == "" ||
            !this.filterStatus ||
            this.status[item.status] == this.filterStatus
          ) {
            aItems.push(item);
          }
        }
      });
      return aItems;
    },
    closePopup() {
      var self = this;
      this.$store.dispatch("mop/loadRequests", {}).then(function() {
        self.bShowMopPopup = false;
      });
    }
  },
  watch: {
    // call again the method if the route changes
    // '$route': 'loadDataPage'
  },
  created() {
    this.$store.commit("setTitle", "Peticiones MOP");
    this.$store.commit("setMenuVisible", false);

    // Load both requests and confirm state
    this.$store.dispatch("mop/loadRequests", {});
    this.$store.dispatch("mop/loadConfirm");
  },
  beforeRouteLeave(to, from, next) {
    next();
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.sidebar-cnt {
  width: 300px;
  display: inline-block;
  float: left;
}
.content {
  width: 100%;
  display: inline-block;
  float: left;
  padding: 20px 40px;

  .header {
    width: 100%;
    text-align: left;
    margin-bottom: 15px;
    overflow: hidden;

    .meta {
      float: left;
      width: 70%;

      .breadcrumbs {
        color: #aaa;
        display: block;
        width: 100%;

        .cat1 {
          display: inline-block;
          font-weight: bold;
          font-family: Speedee-Bold;
        }
        .cat2 {
          display: inline-block;

          &:before {
            content: "|";
            margin: 0 5px;
          }
        }
      }
      .title {
        background: var(--main_color);
        color: var(--dark_color);
        width: auto;
        display: inline-block;
        text-align: left;
        float: left;
        font-size: 25pt;
        font-family: Speedee-Bold;
        padding: 0 5px;
        margin: 0;
        margin-top: 5px;
        line-height: 25pt;
        padding-bottom: 5px;
      }
    }

    .filter {
      float: left;
      width: 30%;
      text-align: right;
      padding: 0 10px;

      .search {
        display: block;
        overflow: hidden;
        margin-top: 5px;
        -webkit-transition: all 1s;
        transition: all 1s;

        .input {
          border: none;
          border-bottom: 2px solid #ccc;
          padding: 5px;
          outline: none;
          background: url("/img/magnify.svg") no-repeat right 5px center;
          background-size: 20px;
          width: 100%;
          float: left;
        }
        .icon {
          display: none;
          cursor: pointer;
          width: 30px;
          height: 30px;
          background: url("/img/go.svg") no-repeat center var(--main_color);
          background-size: 20px;
          border-radius: 3px;
        }
        &.active {
          .input {
            width: calc(100% - 40px);
            background: transparent;
          }
          .icon {
            display: inline-block;
          }
        }
      }
    }
  }
  .filters {
    float: left;
    width: 100%;
    text-align: right;
    padding: 0 10px;
    display: flex;
    align-items: flex-start;
    justify-content: flex-end;

    .filter {
      /* display: inline-block; */
      margin-right: 20px !important;
      flex: 0 0 300px;
      &.switch {
        align-self: center;
      }
    }
    .buttons {
      align-self: center;
      margin-right: 20px;

      a {
        text-decoration: none;
      }
    }
    .search {
      display: block;
      overflow: hidden;
      margin-top: 5px;
      -webkit-transition: all 1s;
      transition: all 1s;

      .input {
        border: none;
        border-bottom: 2px solid #ccc;
        padding: 5px;
        outline: none;
        background: url("/img/magnify.svg") no-repeat right 5px center;
        background-size: 20px;
        width: 100%;
        float: left;
      }
      .icon {
        display: none;
        cursor: pointer;
        width: 30px;
        height: 30px;
        background: url("/img/go.svg") no-repeat center var(--main_color);
        background-size: 20px;
        border-radius: 3px;
      }
      &.active {
        .input {
          width: calc(100% - 40px);
          background: transparent;
        }
        .icon {
          display: inline-block;
        }
      }
    }
  }
}
</style>
